import { render } from "./resourcePrice.vue?vue&type=template&id=17f37335&scoped=true&ts=true"
import script from "./resourcePrice.vue?vue&type=script&lang=ts"
export * from "./resourcePrice.vue?vue&type=script&lang=ts"

import "./resourcePrice.vue?vue&type=style&index=0&id=17f37335&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f37335"]])

export default __exports__